<ul class="chart-control chart-control-compact">
    <li *ngFor="let periodicityOption of PERIODICITY_OPTIONS"
        [ngClass]="{'current': periodicityOption.value === this.periodicity}"
        class="chart-control-item">
        <a (click)="updatePeriodicity(periodicityOption.value)"
           class="chart-control-link" href="javascript:void(0)">
            {{ periodicityOption.label }}
        </a>
    </li>
</ul>
<div class="divider-horizontal"></div>

<div *ngIf="loading" class="stocks d-flex justify-content-center align-items-center" style="height: 360px;">
    <ycn-loading-symbol [loaderMessage]="'Loading Top Gainers and Losers...'"></ycn-loading-symbol>
</div>
<div *ngIf="!loading" class="stocks">
    <div class="stocks-header">
        <div class="stocks-title">Top Gainers</div>
    </div>
    <div *ngIf="!gainersNoData else noData" class="stocks-body">
        <div class="row no-gutters">
            <ng-container *ngFor="let _ of [].constructor(8); index as i">
                <a *ngIf="gainers[i] else emptyCell" class="stock {{ gainers[i].color }} col-3"
                   href="{{ gainers[i].url }}" target="_blank">
                    <div class="stock-header">
                        <span class="stock-title">{{ gainers[i].security_id }}</span>
                    </div>
                    <div class="stock-content">
                        <div class="stock-descr">{{ gainers[i].security_name }}</div>
                        <div class="stock-value">
                            <span>&nbsp;{{ gainers[i].change_percent }}% </span>
                            <span></span>
                        </div>
                    </div>
                </a>
            </ng-container>
        </div>
    </div>
</div>
<div *ngIf="!loading" class="stocks">
    <div class="stocks-header">
        <div class="stocks-title">Top Losers</div>
    </div>
    <div *ngIf="!losersNoData else noData" class="stocks-body">
        <div class="row no-gutters">
            <ng-container *ngFor="let _ of [].constructor(8); index as i">
                <a *ngIf="losers[i] else emptyCell" class="stock {{ losers[i].color }} col-3" href="{{ losers[i].url }}"
                   target="_blank">
                    <div class="stock-header">
                        <span class="stock-title">{{ losers[i].security_id }}</span>
                    </div>
                    <div class="stock-content">
                        <div class="stock-descr">{{ losers[i].security_name }}</div>
                        <div class="stock-value">
                            <span>&nbsp;{{ losers[i].change_percent }}% </span>
                            <span></span>
                        </div>
                    </div>
                </a>
            </ng-container>
        </div>
    </div>
</div>
<ng-template #emptyCell>
    <div class="stock bg-neutral col-3">
        <div class="stock-header"><span class="stock-title">&nbsp;</span></div>
        <div class="stock-content">
            <div class="stock-value"><span>&nbsp;</span> <span>&nbsp;</span></div>
        </div>
    </div>
</ng-template>
<ng-template #noData>
    <div class="stocks-body">
        <div class="row no-gutters">
            <div *ngFor="let _ of [].constructor(8)" class="stock bg-neutral col-3">
                <div class="stock-header"><span class="stock-title">&nbsp;</span></div>
                <div class="stock-content">
                    <div class="stock-value"><span>&nbsp;</span> <span>&nbsp;</span></div>
                </div>
            </div>
        </div>
        <div class="panel-data-empty-message">No Data Available</div>
    </div>
</ng-template>
